import { pathFromFolderchain } from '.'
import { BACKEND_URL } from '../../global';
import keycloak from '../../keycloak';
//Folder chain is a list of folder elements, starting with root and ending with current folder
export async function createFolder(folderName, folderChain, fileMap) {
    try {
        // let filemapToReturn = { ...currentFileMap };
        const path = pathFromFolderchain(folderChain) + folderName + '/';
        const currentFolderId = folderChain[folderChain.length - 1].id
        const date = Date.now().toString();
        const emptyBlob = new Blob(['dummy'], { type: 'application/octet-stream' });
        const formData = new FormData();
        formData.append('file', new File([emptyBlob], `dummy_${date}`));
        formData.append('path', path);
        let newFileData = await fetch(BACKEND_URL + '/upload_audio', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${keycloak.token}`
            },
            body: formData
        }).then(res => res.json())
            .then(r => {
                const newFileMap = { ...fileMap };
                let newFolderChain = [...folderChain]
                const newFileId = r;
                const newFolderId = `new-folder-${date}`;

                newFileMap[newFileId.interview_id] = {
                    draggable: false,
                    droppable: false,
                    id: newFileId.interview_id,
                    interview_id: newFileId.id,
                    isDir: false,
                    isHidden: true,
                    name: newFileId.interview_id,
                    openable: false,
                    parentId: newFolderId,
                    path: path,
                    selectable: false,
                    groups: []
                };
                // Create the new folder
                newFileMap[newFolderId] = {
                    id: newFolderId,
                    name: folderName,
                    isDir: true,
                    modDate: new Date(),
                    parentId: currentFolderId,
                    childrenIds: [newFileId.interview_id],
                    childrenCount: 0
                };

                // Update parent folder to reference the new folder.
                const parent = newFileMap[currentFolderId];
                newFileMap[currentFolderId] = {
                    ...parent,
                    childrenIds: [...parent.childrenIds, newFolderId],
                };
                newFolderChain[newFolderChain.length - 1].childrenIds = [...newFolderChain[newFolderChain.length - 1].childrenIds, newFolderId]
                let returnData = { fileMap: newFileMap, folderChain: newFolderChain }
                return returnData
            });
        return newFileData
    } catch (error) {
        console.error("Error posting data:", error);
        return null; // Handle errors gracefully
    }
}

export default createFolder;